import { render } from "./NewTrip.vue?vue&type=template&id=641216fc&scoped=true"
import script from "./NewTrip.vue?vue&type=script&lang=js"
export * from "./NewTrip.vue?vue&type=script&lang=js"

import "./NewTrip.vue?vue&type=style&index=0&id=641216fc&lang=css"
import "./NewTrip.vue?vue&type=style&index=1&id=641216fc&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641216fc"]])

export default __exports__